/**
 * @file utils/aggregates.js
 * Funzioni di aggregazione ore per risorsa/giorno a partire dal calendario pianificazione.
 *
 * buildResourceDayAggregates: costruisce una mappa { consultantId → { dateKey → hours } }
 * dai record di planning_calendar. Usata in DataContext per calcolare i totali
 * visualizzati nelle celle della griglia Excel.
 */

// Nuovi field: planning_consultant_id, planning_date, hours
export function buildResourceDayAggregates(planningCalendar) {
  const agg = {};
  for (const entry of planningCalendar) {
    const { planning_consultant_id, planning_date, hours } = entry;
    const dateKey = planning_date ? planning_date.split('T')[0] : '';
    if (!agg[planning_consultant_id]) agg[planning_consultant_id] = {};
    agg[planning_consultant_id][dateKey] = hours;
  }
  return agg;
}

export function getCellValue(aggregates, consultantId, dateKey) {
  return aggregates?.[consultantId]?.[dateKey] ?? 0;
}

export function getTotalByConsultant(aggregates, consultantId) {
  const days = aggregates?.[consultantId] ?? {};
  return Object.values(days).reduce((sum, h) => sum + (h || 0), 0);
}
